import { format, parseISO } from 'date-fns'
import $api from '@/plugins/axiosInstance.js'
import CONST from '@/const.js'
import isEmpty from 'lodash/isEmpty'


const state = {
  trackList: [],
  trackTotalCount: 0,
  trackFilteredCount: 0,
  trackInfo: {},

  originArtistList: [],
  artistList: [],
  selectedArtistList: [],
  variousArtistInfo: {},

  originGenreList: [],
  genreList: [],
  selectedGenreList: [],
}
const mutations = {
  
}

const actions = {
  LIST_TRACK: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: '/track', params: payload}).then((result) => {
        return result.data
      })
    }
  },
  LIST_TRACK_MATCH: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: '/track_v2', params: payload}).then((result) => {
        return result.data
      })
    }
  },
  queryTrackList ({ commit }, param) {
    return new Promise((resolve, reject) => {
      $api({
        method: 'get',
        url: '/track',
        params: param
      }).then((res) => {
        commit('SET_TRACK_LIST', res.data.items)
        commit('SET_TRACK_TOTAL_COUNT', { filtered: res.data.filtered, total: res.data.total })
        resolve('/track query ok')
      }).catch((err) => {
        commit('SET_TRACK_LIST', [])
        commit('SET_TRACK_TOTAL_COUNT', 0)
        reject(err)
      })
    })
  },
  queryTrackInfo ({ commit }, url) {
    return new Promise((resolve, reject) => {
      $api({
        method: 'get',
        url: url,
      }).then((res) => {
        commit('SET_TRACK_INFO', res.data)
        resolve('get trackinfo success')
      }).catch((err) => {
        commit('SET_TRACK_INFO', {})
        reject(err)
      })
    })
  },
  
}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  //getters: getters,
}
